"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPopper = require("react-popper");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _excluded = ["styles", "attributes"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ComponentRoot = _styledComponents.default.div.withConfig({
  displayName: "Tooltip__ComponentRoot",
  componentId: "sc-97w218-0"
})(["background:", ";box-shadow:10px 10px 14px 0 rgba(0,0,0,0.19);border-radius:4px;padding:20px;transition:250ms opacity;pointer-events:none;font-family:", ";font-weight:500;font-size:14px;line-height:26px;color:", ";& > *{display:block;}& >:first-child{margin-bottom:20px;}& >:not(:last-child){margin-bottom:10px;}&[data-popper-placement^=\"right\"] > [data-popper-arrow]{left:-4px;}&[data-popper-placement^=\"bottom\"] > [data-popper-arrow]{top:-4px;}&[data-popper-placement^=\"left\"] > [data-popper-arrow]{right:-6px;}&[data-popper-placement^=\"top\"] > [data-popper-arrow]{bottom:-17px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.one[0];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.font1;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.inverted.one[0];
});

var Arrow = _styledComponents.default.div.withConfig({
  displayName: "Tooltip__Arrow",
  componentId: "sc-97w218-1"
})(["width:10px;height:10px;&:before{position:absolute;top:-4px;left:-4px;content:\"\";width:15px;height:15px;z-index:10;background:", ";visibility:visible;transform:translateX(0px) rotate(45deg);transform-origin:center center;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.one[0];
});

var OPTIONS = {
  placement: 'auto',
  strategy: 'absolute',
  modifiers: [{
    name: 'preventOverflow',
    options: {
      padding: 20
    }
  }, {
    name: 'offset',
    options: {
      offset: [0, 20]
    }
  }]
};
var virtualElm = {
  getBoundingClientRect: function getBoundingClientRect() {
    return function () {
      return {
        width: 0,
        height: 0,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      };
    };
  }
};

var Tooltip = function Tooltip(_ref5) {
  var children = _ref5.children;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      tipElm = _useState2[0],
      setTipElm = _useState2[1];

  var _usePopper = (0, _reactPopper.usePopper)(virtualElm, tipElm, OPTIONS),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      popperProps = _objectWithoutProperties(_usePopper, _excluded);

  (0, _react.useEffect)(function () {
    if (tipElm == null) return;

    var setMousePosition = function setMousePosition(_ref6) {
      var clientX = _ref6.clientX,
          clientY = _ref6.clientY;

      virtualElm.getBoundingClientRect = function () {
        return {
          width: 0,
          height: 0,
          top: clientY,
          right: clientX,
          bottom: clientY,
          left: clientX
        };
      };

      if (popperProps.update) popperProps.update();
    };

    document.addEventListener('mousemove', setMousePosition);
    return function () {
      return document.removeEventListener('mousemove', setMousePosition);
    };
  }, [tipElm, popperProps.update]);
  return /*#__PURE__*/_react.default.createElement(ComponentRoot, _extends({
    ref: setTipElm,
    style: styles.popper
  }, attributes.popper), /*#__PURE__*/_react.default.createElement(Arrow, {
    "data-popper-arrow": true,
    style: styles.arrow
  }), children);
};

Tooltip.propTypes = {
  centered: _propTypes.default.bool,
  target: _propTypes.default.any.isRequired
};
Tooltip.defaultProps = {
  centered: false
};
var _default = Tooltip;
exports.default = _default;
//# sourceMappingURL=Tooltip.js.map